import React, { useEffect, useState } from "react";
import TableEditable from "../TableEditable";
import { Input } from "antd";

const Raw = ({ type, updateData, data }) => {
  const { TextArea } = Input;
  const [value, setValue] = useState("");
  const onChange = (e) => {
    setValue(e.target.value);
  };
  useEffect(() => {
    if (type !== "JSON") {
      const newData = data.map(({ categorie, donnees, selected }) => {
        if (categorie === "RAW") {
          if (type !== "JSON") {
            donnees = value;
          }

          return { categorie, donnees, selected, type: type };
        }
        return { categorie, donnees, selected };
      });
      updateData(newData);
    }
  }, [value, type]);

  return type === "JSON" ? (
    <TableEditable updateData={updateData} type="RAW" data={data} />
  ) : (
    <TextArea rows={5} maxLength={300} onChange={onChange} value={value} />
  );
};

export default Raw;
